import QuickSetup from '@/features/quickSetup/QuickSetup';

export default QuickSetup;
